import React, { useState } from "react";
import IdInput from "./IdInput";

interface InitialStepProps {
    onNextStep: () => void
    setUserId: React.Dispatch<React.SetStateAction<string>>;
}

const InitialStep: React.FC<InitialStepProps> = ({ onNextStep, setUserId }) => {
    const [ready, setReady] = useState<boolean>(false);

    return <div className="ContentWrapper">
        <IdInput setReady={setReady} setUserId={setUserId} />
        <button
                onClick={onNextStep}
                disabled={!ready}
                className="register-button"
            >
                Зарегистрироваться
            </button>
    </div>;
}

export default InitialStep;